import { json, CustomerAPI, } from '@driftt/dapper'

export const api = {
  whoIsConnected(integrationName) {
    switch (integrationName) {
      case 'Salesforce':
        return CustomerAPI.get("/salesforce/userinfo").then(json)
      case 'Marketo':
        return CustomerAPI.get("/marketo/config/munchkin").then(json)
      default:
        return {}
    }
  },
  postIntegrationFeedback(integrationName, feedback){
    CustomerAPI.post("/integrations/disconnect/reason", {integrationName, reason: feedback})
  },
  integrationAPICall(integrationEndpoint) {
    return CustomerAPI.get(integrationEndpoint).then(json)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/CommonIntegrationPage/api.js